export type RepairListCategory = 'open' | 'archived';

/** התאמה ל־normalizeRepairStatus במסכי קריאות */
export function normalizeStatusForListCategory(status?: string | null): string {
  if (!status) return '';
  const trimmed = String(status).trim();
  if (trimmed === 'התקבל במעבדה' || trimmed === 'ממתין לטיפול') {
    return 'התקבל, ממתין לטיפול';
  }
  if (trimmed === 'חזר לחנות') {
    return 'חזר ללקוח';
  }
  return trimmed;
}

export function repairListCategoryFromStatus(status?: string | null): RepairListCategory {
  const s = normalizeStatusForListCategory(status);
  /** רק «חזר ללקוח» בארכיון; שאר הסטטוסים בפתוחים */
  return s === 'חזר ללקוח' ? 'archived' : 'open';
}
